import {useQuery} from "@tanstack/react-query";
import {readTopicTypeApi} from "../../../../api/support/common";

/**
 * 지원유형 목록 hook
 * @returns
 */
export const useReadTopicType = () => {
    const res = useQuery({
        queryKey: ["readTopicType"],
        queryFn: async () => await readTopicTypeApi(),
        // staleTime: 6000 * 10,
        select: (res) => res?.result?.CodeEntriesList
    });

    return res;
};
